import { gql } from "apollo-boost";
import { useApolloClient } from "react-apollo";
import { useState, useEffect } from "react";

const GET_PAGE_DATA = gql`
  query {
    albums {
      id
      thumbnail
      name
      status
      created_at
    }
    playlists {
      id
      thumbnail
      name
      description
      status
      created_at
    }
  }
`;

const usePlaylistsAndAlbums = () => {
  const [albums, setAlbums] = useState([]);
  const [playlists, setPlaylist] = useState([]);
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(false);
      try {
        const { data } = await client.query({
          query: GET_PAGE_DATA,
        });
        const filteredAlbums = data.albums
          .filter(album => album.status === "Published")
          .sort((a, b) => {
            if (a.created_at > b.created_at) {
              return -1;
            } else return 1;
          })
          .slice(0, 9);
        const filteredPlaylists = data.playlists
          .slice(0, 3)
          .filter(playlist => playlist.status === "Published")
          .sort((a, b) => {
            if (a.created_at > b.created_at) {
              return -1;
            } else return 1;
          });

        setAlbums(filteredAlbums);
        setPlaylist(filteredPlaylists);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
    };
    fetchData();
  }, [client]);

  return {
    albums,
    playlists,
    loading,
  };
};

export default usePlaylistsAndAlbums;
